import { RefObject, useState } from 'react'
import { useVideoContext } from '../../ActiveVideoContext'

type HookProps = {
  videoRef: RefObject<HTMLVideoElement>
  duration?: number
  canPlayInModal?: boolean
}

const useTimeline = ({ videoRef, duration = 0 }: HookProps) => {
  const [progress, setProgress] = useState(0)
  const { updateCurrentTime } = useVideoContext()

  const handleTimeUpdate = () => {
    if (videoRef.current && duration) {
      const current = videoRef.current.currentTime
      current && updateCurrentTime(current)
      setProgress((current / duration) * 100)
    }
  }

  const handleSeek = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (videoRef.current) {
      const newTime = (Number(event.target.value) / 100) * duration
      videoRef.current.currentTime = newTime
      setProgress(Number(event.target.value))
    }
  }

  const currentTime = duration - (videoRef.current?.currentTime || 0)

  return {
    progress,
    currentTime,
    duration,
    handleTimeUpdate,
    handleSeek,
  }
}

export default useTimeline
